/**
 * 功能名称：list组件
 * 创 建 人：弋强
 * 日    期：2022/05/09 13:29:39
 */
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";

@Component({
    components: {

    }
})
export default class list extends BaseVue {

    //#region 接口定义区

    //#endregion 接口定义区

    //#region 变量定义区

    @Prop({ default: () => ([]) })
    datas?: any[];

    @Prop({ default: undefined })
    format?: Function;

    @Prop({ default: "" })
    itemText?: string;

    // @Prop({ default: "Id" })
    // itemValue?: string;

    selectedItem: any = { isNull: true };
    updateIndex: number = 0;

    //#endregion 变量定义区

    //#region 事件定义区

    mounted() {
        // 页面渲染完出发事件
    }

    //#endregion 事件定义区

    //#region 方法定义区

    @Watch('datas', { immediate: false, deep: true })
    onDatasChanged(val: any, oldVal: any) {
        if (this.isNull(this.datas)) {
            this.selectedItem.isNull = true;
            return;
        }

        let isHasActive = false;
        for (const data of this.datas!) {
            if (this.isActive(data)) {
                isHasActive = true;
            }
        }
        this.selectedItem.isNull = !isHasActive;

        if (this.datas!.length > 0 && this.selectedItem.isNull) {
            this.selectedItem = this.datas![0];
            this.doClick(this.selectedItem, 0);
        }
    }

    renderItem(h, data, index) {
        let itemContent = this.isNull(this.format) ? data[this.itemText!] : this.format!(h, data);
        itemContent = this.isNull(itemContent) ? `列 ${index}` : itemContent;
        const itemDiv = h('div', {
            style: { width: '100%' },
            class: "mb-name",
            on: {
                click: () => {
                    this.doClick(data, index - 1);
                    // this.$forceUpdate();
                }
            }
        }, [itemContent]);

        return h('ListItem', {
            class: this.isActive(data) ? "bt-item bt-item-active" : "bt-item bt-item-no",
            props: {
                key: index,
            }
        }, [itemDiv])
    }

    isActive(data) {
        if(this.isNull(this.selectedItem.Id)) {
            return this.selectedItem == data;
        } else {
            return this.selectedItem == data || this.selectedItem.Id == data.Id;
        }        
    }

    render(h) {
        const listItems: any[] = [];

        if (!this.isNull(this.datas)) {
            let index = 1;
            for (const data of this.datas!) {
                listItems.push(this.renderItem(h, data, index));
                index++;
            }
        }

        return h('div', { class: "bt-content" },
            [
                h('List', {
                    props: {
                        size: 'small'
                    }
                }, listItems)
            ]
        );
    }

    doClick(data, index) {
        this.selectedItem = data;
        this.$emit('click', data, index);
    }

    updateItem() {
        if (this.isNull(this.selectedItem)) {
            return;
        }

        if (this.isNull(this.selectedItem._update_)) {
            this.$set(this.selectedItem, '_update_', 0);
        }
        this.selectedItem._update_ += 1;
        // this.$forceUpdate();
    }

    //#endregion 方法定义区
}